import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { ApplicationService } from '@picard/services-lib';

import { MenuItem } from 'primeng/primeng';

import { HostComponent } from '../host/host.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-sub-menu]',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.css'],
  animations: [
    trigger('children', [
      state('hiddenAnimated', style({ height: '0px' })),
      state('visibleAnimated', style({ height: '*' })),
      state('visible', style({ height: '*', 'z-index': 100 })),
      state('hidden', style({ height: '0px', 'z-index': '*' })),
      transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class SubMenuComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  @Input() item: MenuItem;
  @Input() root: boolean;
  @Input() visible: boolean;
  _reset: boolean;
  _parentActive: boolean;
  activeIndex: number;
  programId: number;
  isActive(index: number): boolean {
    return this.activeIndex === index;
  }
  @Input() get reset(): boolean {
    return this._reset;
  }
  set reset(val: boolean) {
    this._reset = val;
    if (this._reset && (this.hostComponent.isHorizontal() || this.hostComponent.isOverlay())) {
      this.activeIndex = null;
    }
  }
  @Input() get parentActive(): boolean {
    return this._parentActive;
  }
  set parentActive(val: boolean) {
    this._parentActive = val;
    if (!this._parentActive) {
      this.activeIndex = null;
    }
  }
  //#endregion Properties

  //#region Constructor
  constructor(public hostComponent: HostComponent, public menuComponent: MenuComponent, private _applicationService: ApplicationService) {
    this.programId =  parseInt(sessionStorage.getItem('programID')); // this._applicationService.preAuthenticationResponse.programId;
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {}
  itemClick(event: Event, item: MenuItem, index: number) {
    if (this.root) {
      this.hostComponent.menuHoverActive = !this.hostComponent.menuHoverActive;
      event.preventDefault();
    }
    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }
    // activate current item and deactivate active sibling if any
    if (item.routerLink || item.items || item.command || item.url) {
      this.activeIndex = (this.activeIndex as number) === index ? -1 : index;
    }
    // execute command
    if (item.command) {
      item.command({ originalEvent: event, item: item });
    }
    // prevent hash change
    if (item.items || (!item.url && !item.routerLink)) {
      setTimeout(() => {
        this.menuComponent.layoutMenuScrollerViewChild.moveBar();
      }, 450);
      event.preventDefault();
    }
    // hide menu
    if (!item.items) {
      if (this.hostComponent.isMobile()) {
        this.hostComponent.sidebarActive = false;
        this.hostComponent.mobileMenuActive = false;
      }
      if (this.hostComponent.isHorizontal()) {
        this.hostComponent.resetMenu = true;
      } else {
        this.hostComponent.resetMenu = false;
      }
      this.hostComponent.menuHoverActive = !this.hostComponent.menuHoverActive;
    }
  }

  onMouseEnter(index: number) {
    if (this.root && this.hostComponent.menuHoverActive && this.hostComponent.isHorizontal() && !this.hostComponent.isMobile() && !this.hostComponent.isTablet()) {
      this.activeIndex = index;
    }
  }
  //#endregion Functions
}
